export default __webpack_public_path__ + "static/media/hexagon-inner-4.9d73bfaa.svg";